<template>
  <div class="my-auto">
    <div class="container pt-5">
    <article>
      <div class="text-center">
        <span class="material-icons f-xx"> sentiment_satisfied_alt </span>
      </div>
      <h1 class="text-center">Estamos en mantenimiento!</h1>
      <div>
        <p class="text-center">
          Actualmente estamos trabajando para brindarte una mejor expericencia
          como usuario de TreidBlue.
        </p>
        <p class="text-right">&mdash; El equipo de TreidBlue</p>
      </div>
    </article>
    </div>
  </div>
</template>

<script>

export default {
  name: "Maintenance",
};
</script>

<style lang="css" scoped>
.f-xx{
  font-size: 10em;
}
body {
  text-align: center;
}

@media (min-width: 768px) {
h1 {
  font-size: 4em;
}
}

@media (max-width: 767px) {
h1 {
  font-size: 2em;
}
}


body {
  font: 20px Helvetica, sans-serif;
  color: #333;
}
article {
  text-align: left;
  margin: 0 auto;
}
a {
  color: #dc8100;
  text-decoration: none;
}
a:hover {
  color: #333;
  text-decoration: none;
}

</style>